import React from 'react'

const Footer = () => {
  return (
    <div id="footer">
      <a href="https://github.com/bchin224">
      @Brian.Codes
      </a>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js